<template>
    <img
        alt="Smoxy logo"
        width="48" height="48"
        src="@/assets/logo_transparent.svg"
        class="w-12 h-12 p-1 rounded-xl bg-gradient-to-br from-purple-600 to-primary-500" 
        />
</template>